import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// 引入路由
import router from './router/index.js';
import './router/permission.js';


// 引入VUEX
import store from './store';


//引入全局css文件
// import '../src/assets/css/quanJu.css';
import './styles/index.scss';


// 按需引入element ui
// import installElement from './plugins/element'
// Vue.use(installElement)

// 全局引入element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 注册全局过滤器，整个项目所有组件模板都能用
import { formatPriceThousand } from '@/utils/format'
Vue.prototype.$formatPrice = formatPriceThousand


// 导入指令
import vSlidenin from '@/utils/vSlidenin.js';
Vue.directive('sliden-in', vSlidenin)


// 弹窗全局组件
import GlDialog from '@/components/GlDialog.vue'
Vue.component('GlDialog', GlDialog)
// 分页全局组件
import pagination from "@/components/pagination.vue";
Vue.component('pagination', pagination);

// 头部全局组件
import FOOTER from "@/components/footer.vue";
Vue.component('FOOTER', FOOTER);

// 底部全局组件
import HEADER from "@/components/header.vue";
Vue.component('HEADER', HEADER);

// 滑动验证码全局组件
import SlideVerify from "@/components/slideVerify.vue";
Vue.component('SlideVerify', SlideVerify);

// 协议全局组件
import CONFIG from "@/components/config.vue";
Vue.component('CONFIG', CONFIG);
/**
 * 引入全局指令
 * import getNavHeight from '@/utils/navHeight.js';  Vue.prototype.$getNavHeight = getNavHeight; 
*/
new Vue({
	el: '#app',
	render: h => h(App),
	router,
	store
})
